// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ls4YG","left":"styles_left__1SqBP"};